export { useGetJobPostedSuccessLink } from './useGetJobPostedSuccessLink';
